import { render } from "./AppNavigationMenu.vue?vue&type=template&id=5dd72e8a&scoped=true"
import script from "./AppNavigationMenu.vue?vue&type=script&lang=js"
export * from "./AppNavigationMenu.vue?vue&type=script&lang=js"

import "./AppNavigationMenu.vue?vue&type=style&index=0&id=5dd72e8a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dd72e8a"]])

export default __exports__